const ALERT_CIRCLE = "alert-circle";
const ARROW_LEFT = "arrow-left";
const ARROW_RIGHT = "arrow-right";
const BAR_CHART = "bar-chart";
const BAR_CHART_3 = "bar-chart-3";
const BOOK = "book";
const BOOKMARK = "bookmark";
const BRIEFCASE = "briefcase";
const CALENDAR = "calendar";
const CAPITOL_BUILDING = "capitol-building";
const CHECK = "check";
const CHECK_CIRCLE = "check-circle";
const CHECK_SQUARE = "check-square";
const CHEVRON_DOWN = "chevron-down";
const CHEVRON_LEFT = "chevron-left";
const CHEVRON_RIGHT = "chevron-right";
const CHEVRON_UP = "chevron-up";
const CREDIT_CARD = "credit-card";
const CLIPBOARD = "clipboard";
const DOWNLOAD = "download";
const EDIT = "edit";
const EDIT_2 = "edit-2";
const EYE = "eye";
const EYE_OFF = "eye-off";
const FACEBOOK = "facebook";
const FILE = "file";
const FILE_TEXT = "file-text";
const FILTER = "filter";
const FLAG = "flag";
const GIFT = 'gift';
const GRID = "grid";
const GROUP = "group";
const INFO = 'info';
const INSTAGRAM = "instagram";
const LINKEDIN = "linkedin";
const LIST = "list";
const MAIL = "mail";
const MAP = 'map';
const MAP_PIN = "map-pin";
const MAXIMIZE = "maximize-2";
const MESSAGE_CIRCLE = "message-circle";
const MOBILE_MENU = 'mobile-menu';
const MONITOR = "monitor";
const MULTIPLE_FILES = "double-file";
const PHONE = "phone";
const PLAY = "play";
const PLUS = "plus";
const PLUS_CIRCLE = "plus-circle";
const SEARCH = "search";
const SLIDER = "sliders";
const SMART_PHONE = "smartphone";
const STAR = "star";
const TRASH = "trash";
const TWITTER = "twitter";
const UPLOAD = "upload";
const USER = "user";
const USERS = "users";
const X = "x";
const YOUTUBE = "youtube";

export {
  ALERT_CIRCLE,
  ARROW_LEFT,
  ARROW_RIGHT,
  BAR_CHART,
  BAR_CHART_3,
  BOOK,
  BOOKMARK,
  BRIEFCASE,
  CALENDAR,
  CAPITOL_BUILDING,
  CHECK,
  CHECK_CIRCLE,
  CHECK_SQUARE,
  CHEVRON_DOWN,
  CHEVRON_LEFT,
  CHEVRON_RIGHT,
  CHEVRON_UP,
  CREDIT_CARD,
  CLIPBOARD,
  DOWNLOAD,
  EDIT,
  EDIT_2,
  EYE,
  EYE_OFF,
  FACEBOOK,
  FILE,
  FILE_TEXT,
  FILTER,
  FLAG,
  GIFT,
  GRID,
  GROUP,
  INFO,
  INSTAGRAM,
  LINKEDIN,
  LIST,
  MAIL,
  MAP,
  MAP_PIN,
  MAXIMIZE,
  MESSAGE_CIRCLE,
  MOBILE_MENU,
  MONITOR,
  MULTIPLE_FILES,
  PHONE,
  PLAY,
  PLUS,
  PLUS_CIRCLE,
  SEARCH,
  SLIDER,
  SMART_PHONE,
  STAR,
  TRASH,
  TWITTER,
  UPLOAD,
  USER,
  USERS,
  X,
  YOUTUBE
};
